export default function DangerouslySetInnerHTML({ html }: any) {
  return (
    <>
      <div style={{ textAlign: 'left' }}>
        <div dangerouslySetInnerHTML={html} />
      </div>
    </>
  );
}
